import { jsx as _jsx } from "react/jsx-runtime";
import { Popconfirm, App } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { nanoid } from 'nanoid';
import { txt } from 'libs/i18n';
import ResponsiveTable, { useTableView, empiricalScrollHeightAdjust } from 'components/ResponsiveTable';
import * as UserlexAPI from 'api/userlex-api';
import { useSession } from 'components/Authenticated';
import IconButton from 'components/IconButton';
import styles from './style.module.less';
const SCROLL_HEIGHT_ADJUST = empiricalScrollHeightAdjust(195);
const USERLEX_TABLE_ID = 'userlex-table'; // Must be unique across all tables in Beey!!
const UserlexTable = ({ userlex, setUserlex, contentHeight, onOpenEdit, }) => {
    const { message } = App.useApp();
    const { session } = useSession();
    const tableView = useTableView(USERLEX_TABLE_ID);
    const handleDeleteEntry = async (deletedEntry) => {
        const result = await UserlexAPI.putCurrentUserlex(session.connection, userlex.selectedLang, userlex.entries.filter((entry) => entry.key !== deletedEntry.key));
        if (result.isSuccess()) {
            setUserlex(Object.assign(Object.assign({}, userlex), { entries: result.get() }));
            void message.success(txt('ruleDeletedSuccessfully'));
        }
        else {
            void message.error(txt('failedToDeleteRule'));
        }
    };
    const columns = [
        {
            title: txt('incorrectTranscription'),
            key: 'incorrectTranscription',
            dataIndex: 'incorrectTranscription',
            className: 'name-cell',
        },
        {
            title: txt('correctTranscription'),
            key: 'correctTranscription',
            dataIndex: 'correctTranscription',
            className: 'name-cell',
        },
        {
            title: '',
            key: 'Edit',
            width: '40px',
            render: (record) => {
                return (_jsx(IconButton, { onClick: () => onOpenEdit(record), children: _jsx(EditOutlined, {}) }));
            },
        },
        {
            title: '',
            key: 'Delete',
            width: '40px',
            render: (record) => {
                return (_jsx(Popconfirm, { title: txt('deletePermanently'), okText: txt('delete'), okButtonProps: { danger: true }, okType: "primary", onConfirm: () => handleDeleteEntry(record), cancelText: txt('cancel'), placement: "topLeft", children: _jsx(IconButton, { danger: true, children: _jsx(DeleteOutlined, {}) }) }));
            },
        },
    ];
    return (_jsx(ResponsiveTable, { bordered: false, className: styles.table, columns: columns, dataSource: userlex.entries, rowKey: () => nanoid(5), tableView: tableView, recordCount: userlex.entries.length, pageSizeOptions: ['50', '100', '200'], scroll: { x: 400, y: contentHeight - SCROLL_HEIGHT_ADJUST }, stripeRows: true }));
};
export default UserlexTable;
